module.exports = __webpack_public_path__ + "img/smart-car-icon.5f87c85b.png";